module.exports = __webpack_public_path__ + "static/media/tg.bffc7318.svg";